import React from 'react';
import { Input } from './styles/form.style';
import styled from 'styled-components';
import colors from '@styles/common/colors';

interface ArticleFormInputProps {
  label: string;
  name: string;
  value?: any;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ArticleFormInput: React.FC<ArticleFormInputProps> = ({ label, name, value, onChange }) => {
  return (
    <div>
      <Label>{label}</Label>
      <Input type="text" name={name} value={value ?? ''} onChange={onChange} required />
    </div>
  );
};

export default ArticleFormInput;

const Label = styled.div`
  margin-top: 2px;
  color: ${colors.text_grey};
  letter-spacing: 1px;
`;
